









































import { useAlgoliaSearch } from '@algolia-search/composables/useAlgoliaSearch';
import useAlgoliaSearchStore from '@algolia-search/stores/algoliaSearch';
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  ref
} from '@nuxtjs/composition-api';
import { SfLink } from '@storefront-ui/vue';
import throttle from 'lodash.throttle';

import { useLink } from '~/diptyqueTheme/composable';
import { useMegaMenuMobileStore } from '~/diptyqueTheme/stores/megaMenuMobile';

export default defineComponent({
  name: 'TopSearches',
  components: {
    SfLink,
    SkeletonLoader: () => import('~/components/SkeletonLoader/index.vue'),
    SectionHeading: () =>
      import(
        '@algolia-search/components/atoms/SectionHeading/SectionHeading.vue'
      )
  },
  props: {
    heading: {
      type: String,
      default: ''
    }
  },
  setup() {
    const { fetchTopSearches, topSearches, isTopSearchesLoading } =
      useAlgoliaSearch();
    const { normalizeLink } = useLink();
    const searchStore = useAlgoliaSearchStore();
    const megaMenuMobileStore = useMegaMenuMobileStore();

    const searchList = ref<HTMLElement | null>(null);
    const scrollPosition = ref(0);
    const contentScrollWidth = ref(0);
    const RIGHT_FADE_THRESHOLD = 1;
    const SCROLL_THROTTLE_DELAY = 100;

    const showRightFade = computed(
      () =>
        scrollPosition.value < RIGHT_FADE_THRESHOLD &&
        searchList.value?.scrollWidth !== searchList.value?.offsetWidth
    );

    const checkScroll = () => {
      const wrapper = searchList.value;
      if (!wrapper) return;

      contentScrollWidth.value = wrapper.scrollWidth - wrapper.offsetWidth;
      scrollPosition.value = wrapper.scrollLeft / contentScrollWidth.value;
    };

    const handleTopSearchClick = () => {
      searchStore.setSearchModalOpen(false);
      megaMenuMobileStore.hide();
    };

    onMounted(async () => {
      // TODO: Move fetchTopSearches logic to a plugin
      await fetchTopSearches();

      if (searchList.value) {
        searchList.value.addEventListener(
          'scroll',
          throttle(checkScroll, SCROLL_THROTTLE_DELAY)
        );
      }
    });

    onUnmounted(() => {
      if (searchList.value) {
        searchList.value.removeEventListener('scroll', checkScroll);
      }
    });

    return {
      isTopSearchesLoading,
      topSearches,
      normalizeLink,
      searchList,
      showRightFade,
      handleTopSearchClick,
      isTopSearchesAvailable: computed(() => topSearches.value?.length)
    };
  }
});
